const Mutations = Object.freeze({
	SET_GRID_DATA: 'gridsModule/gridsRecordHistory/SET_GRID_DATA',
	SET_TOTAL_COUNT: 'gridsModule/gridsRecordHistory/SET_TOTAL_COUNT',
	SET_GRID_VIEW: 'gridsModule/gridsRecordHistory/SET_GRID_VIEW',
	SET_COLUMNS: 'gridsModule/gridsRecordHistory/SET_COLUMNS',
	SET_IRIS_USER_METADATA:
		'gridsModule/gridsRecordHistory/SET_IRIS_USER_METADATA',
});
export const Actions = Object.freeze({
	CLEAR: 'gridsModule/gridsRecordHistory/CLEAR',
	LOAD_GRID_DATA: 'gridsModule/gridsRecordHistory/LOAD_GRID_DATA',
	LOAD_GRID_VIEW: 'gridsModule/gridsRecordHistory/LOAD_GRID_VIEW',
});
export const Getters = Object.freeze({
	GRID_DATA: 'gridsModule/gridsRecordHistory/GRID_DATA',
	GRID_DATA_COUNT: 'gridsModule/gridsRecordHistory/GRID_DATA_COUNT',
	IRIS_USER_METADATA: 'gridsModule/gridsRecordHistory/IRIS_USER_METADATA',
});

import dataService from '../../../../../services/data/projectGridsService';
import { GeneralActions } from '../../../../actions';
export default {
	state: {
		gridView: null,
		visibleColumns: [],
		gridData: [],
		totalCount: 0,
		itemsPerPage: 50,
		page: 1,
		irisUsersMetadata: [],
	},
	mutations: {
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, items) {
			state.totalCount = items;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_GRID_DATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				resolve();
			});
		},
		[Actions.LOAD_GRID_DATA]({ commit, dispatch }, payload) {
			return new Promise((resolve) => {
				dataService
					.getGridAssetHistory(payload)
					.then((resp) => {
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					});
			});
		},
	},
	getters: {
		[Getters.GRID_DATA](state) {
			return JSON.parse(JSON.stringify(state.gridData));
		},
		[Getters.GRID_DATA_COUNT](state) {
			return state.totalCount;
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
	},
};
